<template>
  <section id="template">
    <!-- <div class="modal fade" id="modal-email" tabindex="-2"> -->
    <!-- <div class="modal-dialog modal-dialog-centered" role="document"> -->
    <!-- <div class="modal-content"> -->
    <body
      data-v-38e062e2=""
      style="
        background-color: rgb(246, 246, 246);
        font-family: sans-serif;
        -webkit-font-smoothing: antialiased;
        font-size: 14px;
        line-height: 1.4;
        margin: 0px;
        padding: 0px;
        text-size-adjust: 100%;
      "
    >
      <table
        role="presentation"
        border="0"
        cellpadding="0"
        cellspacing="0"
        class="body"
        width="100%"
        bgcolor="#f6f6f6"
        data-v-38e062e2=""
        style="
          border-collapse: separate;
          background-color: rgb(246, 246, 246);
          width: 100%;
        "
      >
        <tr data-v-38e062e2="">
          <td
            valign="top"
            data-v-38e062e2=""
            style="
              font-family: sans-serif;
              font-size: 14px;
              vertical-align: top;
            "
          >
            &nbsp;
          </td>
          <td
            class="container"
            width="580"
            valign="top"
            data-v-38e062e2=""
            style="
              font-family: sans-serif;
              font-size: 14px;
              vertical-align: top;
              display: block;
              max-width: 580px;
              padding: 10px;
              width: 580px;
              margin: 0px auto;
            "
          >
            <div
              class="content"
              data-v-38e062e2=""
              style="
                box-sizing: border-box;
                display: block;
                margin: 0px auto;
                max-width: 580px;
                padding: 10px;
              "
            >
              <!-- START CENTERED WHITE CONTAINER -->
              <table
                role="presentation"
                class="main"
                width="100%"
                data-v-38e062e2=""
                style="
                  border-collapse: separate;
                  background: rgb(255, 255, 255);
                  border-radius: 3px;
                  width: 100%;
                "
              >
                <!-- START MAIN CONTENT AREA -->
                <tr data-v-38e062e2="">
                  <td
                    class="wrapper"
                    valign="top"
                    data-v-38e062e2=""
                    style="
                      font-family: sans-serif;
                      font-size: 14px;
                      vertical-align: top;
                      box-sizing: border-box;
                      padding: 20px;
                    "
                  >
                    <table
                      role="presentation"
                      border="0"
                      cellpadding="0"
                      cellspacing="0"
                      width="100%"
                      data-v-38e062e2=""
                      style="border-collapse: separate; width: 100%"
                    >
                      <tr data-v-38e062e2="">
                        <td
                          valign="top"
                          data-v-38e062e2=""
                          style="
                            font-family: sans-serif;
                            font-size: 14px;
                            vertical-align: top;
                          "
                        >
                          <!-- Hero Image -->

                          <div class="default-style mb-2" data-v-38e062e2="">
                            <img
                              class="aspect-ratio"
                              src="https://marido-image-bucket.s3.amazonaws.com/marido.baner.png"
                              alt=""
                              data-v-38e062e2=""
                              style="max-width: 100%"
                            />
                          </div>

                          <!-- Center Text Body Content -->
                          <div id="TextBodyContent">
                            <br data-v-38e062e2="" />

                            <p>
                              Hi <strong>{{ emailContainer.name }}</strong
                              >,
                            </p>
                            <p>
                              A friend of yours thought that you would be
                              interested in getting to know
                              Marido-en-alquiler.com, a platform where you can
                              finally find high quality home renovations
                              contractors.
                            </p>
                            <p>
                              Regardless of the size of your home project,
                              Marido-en-alquiler has thousands of contractors to
                              choose from.
                            </p>
                            <p>
                              Start searching for them today however if you to
                              need our help, don&apos;t hesitate to leave us a
                              message at
                              <a
                                href="https://www.marido-en-alquiler.com/contactus"
                                >https://www.marido-en-alquiler.com/contactus</a
                              >
                              or just send us an email at
                              <a href="mailto:hello@target-innovations.com"
                                >hello@target-innovations.com</a
                              >
                            </p>
                            <p>
                              Create your profile today and start executing your
                              project as you always wanted.<br />We hope you
                              enjoy using Marido-en-alquiler as much as we
                              enjoyed creating it!<br /><br />Sincerely,<br /><strong
                                >The Marido-en-alquiler Team</strong
                              ><br /><br />Our community is growing rapidly and
                              we hope you tell friends about us.<br /><br />
                            </p>
                          </div>

                          <!-- Center Data Table Content -->
                          <div id="dataTable"></div>

                          <!-- Call For Action Buttons -->
                          <table
                            role="presentation"
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            class="btn btn-secondary"
                            width="100%"
                            data-v-38e062e2=""
                            style="
                              border-collapse: separate;
                              box-sizing: border-box;
                              width: 100%;
                            "
                          >
                            <tbody data-v-38e062e2="">
                              <tr data-v-38e062e2="">
                                <td
                                  align="center"
                                  valign="top"
                                  data-v-38e062e2=""
                                  style="
                                    font-family: sans-serif;
                                    font-size: 14px;
                                    padding-bottom: 10px;
                                  "
                                >
                                  <table
                                    role="presentation"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    data-v-38e062e2=""
                                    style="
                                      border-collapse: separate;
                                      width: auto;
                                    "
                                  >
                                    <tbody data-v-38e062e2="">
                                      <tr data-v-38e062e2="">
                                        <td
                                          valign="top"
                                          align="center"
                                          data-v-38e062e2=""
                                          style="
                                            font-family: sans-serif;
                                            font-size: 14px;
                                            vertical-align: top;
                                            border-radius: 5px;
                                            text-align: center;
                                          "
                                        >
                                          <a
                                            href="https://www.marido-en-alquiler/comoferreterias"
                                            target="_blank"
                                            data-v-38e062e2=""
                                            style="
                                              border: 1px solid green;
                                              border-radius: 5px;
                                              box-sizing: border-box;
                                              cursor: pointer;
                                              display: inline-block;
                                              font-size: 14px;
                                              font-weight: bold;
                                              margin: 10px;
                                              padding: 12px 25px;
                                              text-decoration: none;
                                              text-transform: capitalize;
                                              background-color: green;
                                              color: rgb(255, 255, 255);
                                            "
                                            >Tell A Friend</a
                                          >
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- END MAIN CONTENT AREA -->
              </table>
              <!-- END CENTERED WHITE CONTAINER --><!-- START FOOTER -->
              <div
                class="footer"
                data-v-38e062e2=""
                style="
                  clear: both;
                  margin-top: 10px;
                  text-align: center;
                  width: 100%;
                "
              >
                <table
                  role="presentation"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  width="100%"
                  data-v-38e062e2=""
                  style="border-collapse: separate; width: 100%"
                >
                  <!-- Social Links -->
                  <tr data-v-38e062e2="">
                    <td
                      data-v-38e062e2=""
                      style="text-align: center; vertical-align: middle"
                    >
                      <div data-v-38e062e2="">
                        <div
                          class="social"
                          data-v-38e062e2=""
                          style="display: inline-block; padding: 3px 3px"
                        >
                          <a
                            href="https://www.facebook.com/LuizBreak/"
                            target="_blank"
                            data-v-38e062e2=""
                            ><img
                              width="29"
                              height="29"
                              src="https://cdn.gifo.wisestamp.com/s/facebook/EE6A2F/58/circle/border.png"
                              border="0"
                              data-v-38e062e2=""
                          /></a>
                        </div>
                        <div
                          class="social"
                          data-v-38e062e2=""
                          style="display: inline-block; padding: 3px 3px"
                        >
                          <a
                            href="https://www.instagram.com/luis.break/"
                            target="_blank"
                            data-v-38e062e2=""
                            ><img
                              width="29"
                              height="29"
                              src="https://cdn.gifo.wisestamp.com/s/instagram/EE6A2F/58/circle/border.png"
                              border="0"
                              data-v-38e062e2=""
                          /></a>
                        </div>
                        <div
                          class="social"
                          data-v-38e062e2=""
                          style="display: inline-block; padding: 3px 3px"
                        >
                          <a
                            href="https://www.youtube.com/channel/UCzWIkivSVgOqPYMsOu7pIww"
                            target="_blank"
                            data-v-38e062e2=""
                            ><img
                              width="29"
                              height="29"
                              src="https://cdn.gifo.wisestamp.com/s/youtube/EE6A2F/58/circle/border.png"
                              border="0"
                              data-v-38e062e2=""
                          /></a>
                        </div>
                        <div
                          class="social"
                          data-v-38e062e2=""
                          style="display: inline-block; padding: 3px 3px"
                        >
                          <a
                            href="https://github.com/LuizBreak"
                            target="_blank"
                            data-v-38e062e2=""
                            ><img
                              width="29"
                              height="29"
                              src="https://cdn.gifo.wisestamp.com/s/github/EE6A2F/58/circle/border.png"
                              border="0"
                              data-v-38e062e2=""
                          /></a>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr data-v-38e062e2="">
                    <td
                      class="content-block"
                      valign="top"
                      align="center"
                      data-v-38e062e2=""
                      style="
                        font-family: sans-serif;
                        vertical-align: top;
                        padding-bottom: 10px;
                        padding-top: 10px;
                        color: rgb(153, 153, 153);
                        font-size: 12px;
                        text-align: center;
                      "
                    >
                      <span
                        class="apple-link"
                        data-v-38e062e2=""
                        style="
                          color: rgb(153, 153, 153);
                          font-size: 12px;
                          text-align: center;
                        "
                        >Marido-en-alquiler, Distrito Nacional, Santo
                        Domingo</span
                      ><br data-v-38e062e2="" />
                      Don't like these emails?
                      <a
                        href="http://www.target-innovations.com"
                        data-v-38e062e2=""
                        style="
                          text-decoration: underline;
                          color: rgb(153, 153, 153);
                          font-size: 12px;
                          text-align: center;
                        "
                        >Unsubscribe</a
                      >.
                    </td>
                  </tr>
                  <tr data-v-38e062e2="">
                    <td
                      class="content-block powered-by"
                      valign="top"
                      align="center"
                      data-v-38e062e2=""
                      style="
                        font-family: sans-serif;
                        vertical-align: top;
                        padding-bottom: 10px;
                        padding-top: 10px;
                        color: rgb(153, 153, 153);
                        font-size: 12px;
                        text-align: center;
                      "
                    >
                      Powered by
                      <a
                        href="http://www.target-innovations.com"
                        data-v-38e062e2=""
                        style="
                          color: rgb(153, 153, 153);
                          font-size: 12px;
                          text-align: center;
                          text-decoration: none;
                        "
                        >Target Innovations</a
                      >
                    </td>
                  </tr>
                </table>
              </div>
              <!-- END FOOTER -->
            </div>
          </td>
          <td
            valign="top"
            data-v-38e062e2=""
            style="
              font-family: sans-serif;
              font-size: 14px;
              vertical-align: top;
            "
          >
            &nbsp;
          </td>
        </tr>
      </table>
    </body>
    <!-- </div> -->
    <!-- </div> -->
    <!-- </div> -->
  </section>
</template>

<script>
export default {
  name: "bid-email-template",
  props: ["projectId", "projectTitle"],
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    contractor: {
      get() {
        return { ...this.$store.getters["contractors/contractor"] };
      },
    },
    emailContainer() {
      return this.$store.getters["emailContainer"];
    },
  },
  mounted() {},
};
</script>
<style scoped></style>
